import React from 'react';
import {PageHelmet} from 'components/Pages';

function LandingHelmet() {
  const title = `IAF Certification Validation - IAF CertSearch`;
  const description = `IAF CertSearch is the exclusive global database for accredited management system certifications allowing users to validate an organization's certification(s).`;

  return <PageHelmet title={title} description={description} />;
}

export default LandingHelmet;
